// Search/buy merch pages
export const MERCH = '/merch';
export const AMAS = '/personal-videos';
export const EXPERIENCES = '/experiences';
export const PRODUCTS = '/products';
export const STREAMS = '/streams';
export const ORDER_MERCH = '/order-merch';
export const ORDER_AMA = '/order-personal-videos';
// Checkout
export const STREAM_CHECKOUT = '/checkout/stream';
export const CHECKOUT_INFORMATION = '/checkout/information';
export const CHECKOUT_SHIPPING = '/checkout/shipping';
export const CHECKOUT_PAYMENT = '/checkout/payment';
export const CHECKOUT_CONFIRMATION = '/checkout/confirmation';
// Store management (dashboard)
export const DASHBOARD = '/dashboard';
export const PROFILE = '/profile';
export const MY_SALES = '/my-sales';
// Index of the "Personal Video Requests" tab in components/MySales/MySales.tsx
export const MY_SALES_PERSONAL_VIDEO_REQUESTS = `${MY_SALES}?tab=3`;
export const MANAGE_MERCH = '/manage-merch';
export const MANAGE_MERCH_CREATE_MERCH = `${MANAGE_MERCH}/create-merch`;
export const AMA_REQUEST = '/personal-videos-request';
export const PERSONAL_VIDEO_SETUP = '/brand-deals';
export const MANAGE_AMA = '/manage-brand-deals';
export const MANAGE_BRAND_DEALS_MESSAGES = '/manage-brand-deals/messages';
export const ACCOUNT_PRODUCTS = '/account-products';
export const AUTO_MERCH = '/auto-merch';
export const MANAGE_STREAMS = '/manage-streams';
export const MANAGE_INTERVIEWS = '/manage-interviews';
export const MANAGE_EXPERIENCES = '/manage-experiences';
export const MEDIA = '/media/';
export const MEDIA_LIBRARY = '/media-library';
export const MEDIA_POSTS_LIBRARY = '/media-posts-library';
export const SOCIAL_MEDIA_POST = '/social-media-post/';
export const VIDEO_SOCIAL_MEDIA_POST = '/social-media-post/video/';
export const VIDEO_WATCH_STREAM = '/video-stream/';
export const SCHEDULE_STREAM = '/schedule-stream';
export const MEMORABILIA = '/memorabilia';
export const PURCHASES = '/orders';
export const ADDRESSES = '/addresses';
export const PROFILE_SETUP = '/profile-setup';
export const ACCOUNT_SETTINGS = '/account-settings';
export const SPONSORED_CHANNEL = '/sponsored-channel';
export const AFFILIATE_EARNINGS = '/affiliate-earnings';
export const NOTIFICATIONS = '/notifications';
export const USER_SCHEDULE_INTERVIEW = '/user-schedule-interview';
export const SCHEDULE_INTERVIEW = '/schedule-interview';
export const UPLOAD_NEW_MEDIA = '/upload-new-media';
// Utility
export const HOME = '/';
export const SEARCH = '/search';
export const JOIN_MATCHUP = '/join';
export const ABOUT_US = '/about-us';
export const FIND_YOUR_ORDER = '/find-your-order';
export const ATHLETES = '/athletes';
export const BOXING = '/boxing';
export const MMA = '/mma';
export const PRIVACY_POLICY = '/privacy-policy';
export const TERMS_OF_SERVICE = '/terms-of-service';
export const THANK_YOU = '/thank-you';
export const THANK_YOU_VIDEO = '/thank-you-video';
export const GYMS = '/gyms';
export const CREATORS = '/creators';
export const TAG = '/tag';
export const SPORTS = '/sports';
// Landing pages
export const CLAIM_YOUR_PROFILE = '/landing/claim-your-profile';
// Campaigns
export const SUBMIT_TIMELINE = '/submit-timeline';
export const CAMPAIGN_BRIEF = 'campaign-brief';
export const CAMPAIGN_DETAILS_PAGE = 'details';
